import React, { useState } from 'react'
import styled from 'styled-components'
import { Box, getPaletteColor, Image, Text, Absolute, Relative, Flex, Card } from 'pcln-design-system'
import { ExpressDealTutorialBox } from '@pcln/fly-ui-components'
import { ExpressDealInfoCard } from '@pcln/horizon-fly-components'
import { Modal } from 'pcln-modal'
import { executeCallbacksOnEnterSpaceClick } from '../../util/executeCallbacksOnEnterSpaceClick'
import { Logo as ExpDealLogo } from '@pcln/express-deals'
import { logEvent } from '@mfs/client/common/log-ga-event/logGaEvent'

const StyledImage = styled(Image)`
  opacity: 0.8;
`

const StyledCard = styled(Card)`
  cursor: pointer;
  overflow: hidden;
`

const StyledImageBox = styled(Box)`
  border-top: 8px solid ${getPaletteColor('primary.base')};
`

const imgSrc = 'https://s1.pclncdn.com/design-assets/fly-images/airlines-exd.webp?opto&height=370&width=300'

const ExpressDealFiltersContainer = ({ isExdCardVariant = false }) => {
  const [infoModalOpen, setInfoModalOpen] = useState(false)

  const toggleInfoModal = (e) => {
    // Since this can be used in a parent that also has an onClick event, we need to prevent
    // this event from bubbling up
    e.preventDefault()
    e.stopPropagation()

    setInfoModalOpen((prev) => {
      const next = !prev

      if (isExdCardVariant && next) {
        logEvent('internal_element', {
          type: 'what_are_exds_banner',
          link_name: 'what_are_express_deals',
          page_name: 'listings',
          product_name: 'air',
        })
      }
      return next
    })
  }

  const accessibleToggleInfoModal = (e) => {
    executeCallbacksOnEnterSpaceClick([toggleInfoModal], e)
  }

  return (
    <Relative mb={'24px'}>
      <Modal
        isOpen={infoModalOpen}
        width={['690px']}
        disableCloseButton={false}
        enableOverflow
        onClose={toggleInfoModal}
        bg='white'
      >
        <ExpressDealTutorialBox />
      </Modal>
      {isExdCardVariant ? (
        <ExpressDealInfoCard
          accessibleToggleInfoModal={accessibleToggleInfoModal}
          expDealLogo={
            <ExpDealLogo
              customHeight={20}
              shouldRenderBadge={false}
              isPlural={false}
              showTrademark
              isTextColorLight
            />
          }
        />
      ) : (
        <StyledCard
          tabIndex={0}
          onKeyDown={accessibleToggleInfoModal}
          onClick={accessibleToggleInfoModal}
          boxShadowSize='md'
          borderRadius='xl'
        >
          <StyledImageBox color='border.shade'>
            <StyledImage
              width={'240px'}
              height={'115px'}
              loading='lazy'
              src={imgSrc}
              alt='Airplane wing over a coastline with blue ocean and clear skies seen from a plane window.'
              objectFit='cover'
            />
          </StyledImageBox>
          <Absolute width={1} top={54}>
            <Flex width={1} justifyContent='center'>
              <ExpDealLogo
                customHeight={16}
                isPlural={true}
                size={'lg'}
                showTrademark={false}
                shouldRenderBadge={false}
                isTextColorLight={true}
              />
            </Flex>
          </Absolute>
          <Absolute bottom={44}>
            <Text fontSize={0} bold textAlign='center' p='2px' color='text.lightest'>
              Exclusive discounts with trusted airlines
            </Text>
          </Absolute>
          <Box>
            <Flex height='40px' justifyContent='center' alignItems='center'>
              <Text fontSize={0} bold color='primary.base'>
                What are Express Deals?
              </Text>
            </Flex>
          </Box>
        </StyledCard>
      )}
    </Relative>
  )
}

export { ExpressDealFiltersContainer }
